<template>
  <div>
    <section class="container-mask form-wrap9">
      <div class="container form-mask" style="width:25rem;">
        <div action="" class="wrap7p">
          <div class="iconf close-iconf" @click="hideChatQr"></div>
          <img style="width:10.6rem; display:block; margin: 1.8rem auto 0" :src='this.$store.state.baseURL + "/new/images/wwww.jpg"'>
          <p style="font-size:0.9rem; text-align: center; line-height: 1.23; color: #1b1b1b;">
            Please <span class="c1">scan the WeChat QR Code</span> to<br />add our academic advisor<br />and receive additional details.
          </p>
          <div class="oks oks-wrap9" style="margin: 1.5rem auto 2.5rem; cursor: pointer;padding: 10px 0;" @click="hideChatQr">BACK</div>
        </div>
      </div>
    </section>
	</div>
</template>

<script>
  export default {
    props: {

    },
    data(){
      return{

      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      showChatQr() {
        $('.form-wrap9').addClass('show');
      },
      hideChatQr() {
        $('.form-wrap9').removeClass('show');
      }
    }
  }
</script>

<style scoped>
  .ui.primary.button {
    font-size: 0.9rem;
  }
  

  .main-QA {
    padding-top: 1rem;
  }

  .m-box {
    margin-top: 20px;
  }

  .m-item {
    width: 50%;
  }

  .m-box .line {
    margin: 0 10px;
    display: block;
    width: 1px;
  ;
    height: 200px;
    background: #3b52f6;
  }

  .m-item h5 {
    text-align: left;
    font-size: 22px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact/QrCode.vue